import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_5: FaireProductEntity = {
  token: "catalog_prod_prod-5",
  type: "product",
  name: "Mini Pillows - Celebrate (3 Styles)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 83.49,
  msrpDollars: 208.73,
  sku: "CO0005",
  caseSize: 4,
  material: "Ceramic",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 122,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
